// ** React Imports
import {Suspense, lazy} from 'react'
import ReactDOM from 'react-dom'

// ** Redux Imports
import {Provider} from 'react-redux'
import {store} from './redux/storeConfig/store'

// ** Intl, CASL & ThemeColors Context
import ability from '@configs/acl/ability'
import {ToastContainer} from 'react-toastify'
import {AbilityContext} from '@src/utility/context/Can'
import {ThemeContext} from '@src/utility/context/ThemeColors'
import {IntlProviderWrapper} from '@src/utility/context/Internationalization'
import {GlobalDefinitionsProviderWrapper} from "@csrc/utility/context/GlobalDefinitions"
import {registerSyncFusionLicense, env} from "@utils"

// ** Spinner (Splash Screen)
import Spinner from '@components/spinner/Fallback-spinner'

// ** Ripple Button
import '@components/ripple-button'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** Core styles
import '@assets/fonts/feather/iconfont.css'
import '@styles/core.scss'
import '@src/assets/scss/style.scss'
import './assets/scss/style.scss'

import './assets/fonts/mark-pro/3B069A_0_0.eot'
import './assets/fonts/mark-pro/3B069A_0_0.ttf'
import './assets/fonts/mark-pro/3B069A_0_0.woff'
import './assets/fonts/mark-pro/3B069A_0_0.woff2'
import './assets/fonts/mark-pro/3B069A_1_0.eot'
import './assets/fonts/mark-pro/3B069A_1_0.ttf'
import './assets/fonts/mark-pro/3B069A_1_0.woff'
import './assets/fonts/mark-pro/3B069A_1_0.woff2'
import './assets/fonts/mark-pro/3B069A_2_0.eot'
import './assets/fonts/mark-pro/3B069A_2_0.ttf'
import './assets/fonts/mark-pro/3B069A_2_0.woff'
import './assets/fonts/mark-pro/3B069A_2_0.woff2'
// ** Service Worker
import * as serviceWorker from './serviceWorker'
import {genLang} from "./assets/data/locales"
import {officeLang} from "./modules/office"
import {dashboardLang} from "./modules/dashboard"
import {requestLang} from "./modules/request"
import {trainingLang} from "./modules/training"
import {documentLang} from "./modules/document"
import {meetingLang} from "./modules/meeting"
import {settingsLang} from "./modules/settings"
import {formsLang} from "./modules/forms"

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

const additionalLangs = {
	en: {...genLang.en, ...officeLang.en, ...dashboardLang.en, ...requestLang.en, ...trainingLang.en, ...documentLang.en, ...meetingLang.en, ...settingsLang.en, ...formsLang.en },
	de: {...genLang.de, ...officeLang.de, ...dashboardLang.de, ...requestLang.de, ...trainingLang.de, ...documentLang.de, ...meetingLang.de, ...settingsLang.de, ...formsLang.de },
	fr: {...genLang.fr, ...officeLang.fr, ...dashboardLang.fr, ...requestLang.fr, ...trainingLang.fr, ...documentLang.fr, ...meetingLang.fr, ...settingsLang.fr, ...formsLang.fr }
}

registerSyncFusionLicense()
ReactDOM.render(
	<Provider store={store}>
		<Suspense fallback={<Spinner/>}>
			<AbilityContext.Provider value={ability}>
				<ThemeContext>
					<GlobalDefinitionsProviderWrapper>
						<IntlProviderWrapper additionalLangs={additionalLangs}>
							<LazyApp/>
							<ToastContainer newestOnTop/>
						</IntlProviderWrapper>
					</GlobalDefinitionsProviderWrapper>
				</ThemeContext>
			</AbilityContext.Provider>
		</Suspense>
	</Provider>,
	document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
